export const CircleIconFilled = ({ ...props }) => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="10.5" cy="10.5" r="9.5" stroke="#3A3331" stroke-width="2" />
    <circle cx="10.5" cy="10.5" r="6.5" fill="#3A3331" />
  </svg>
);
